// Stacking for the post-login passkey dialog.
//
// It portals to document.body, so the layout's own `#layout-3 .ant-modal-wrap { z-index: 1200 }`
// never matches it and antd's default 1000 leaves it UNDER the header (1002) and the sider (1001).
// The chrome then sits on top of the dialog and swallows every click meant for Later and the close
// button — which is exactly how it became impossible to dismiss, with its mask leaving the whole
// portal unnavigable (QA, production, 2026-08-29).
//
// 1100 matches TwoFactorChallengeModal, mounted beside it in App.js and portalling the same way.
//
// Kept in its own module deliberately: the dialog imports apollo and axios, so anything that has to
// read this value in a test cannot afford to import the component to get it.
export const PASSKEY_PROMPT_Z_INDEX = 1100;

export default PASSKEY_PROMPT_Z_INDEX;
